const pendingApprovalForToFinance = ({ initiatives }) => {
  if (!initiatives || !Array.isArray(initiatives)) {
    console.warn('pendingApprovalForWorkstreamLead: initiatives is not a valid array', initiatives);
    return { pending: [], approved: [], notSet: [] };
  }
  const pendingTO = [];
  const approvedTO = [];
  const notSetTO = [];
  const approvalStageMap = {
    'Submitted for L2 Approval': 'L2',
    'Submitted for L3 Approval': 'L3',
    'Submitted for L4 Approval': 'L4',
    'Submitted for L5 Approval': 'L5',
  };

  initiatives.forEach((initiative) => {
    let categorized = false;

    if (initiative.hasFinancialImpact === true) {
      if (initiative.request && initiative.request.requestedStage) {
        const stage = initiative.stage;
        const requestedStage = initiative.request.requestedStage;
        const approvalStageKey = approvalStageMap[requestedStage];
        const isStageValidForApproval = (currentStage, requestedApprovalKey) => {
          if (!requestedApprovalKey) return false; // If no mapping found, it's not valid

          const stageNumber = parseInt(currentStage.replace('L', ''));
          const requestedApprovalNumber = parseInt(requestedApprovalKey.replace('L', ''));
          return requestedApprovalNumber === stageNumber || requestedApprovalNumber === stageNumber + 1;
        };

        if (approvalStageKey && isStageValidForApproval(stage, approvalStageKey)) {
          if (initiative.approvalSummary && initiative.approvalSummary[approvalStageKey]) {
            const approvers = initiative.approvalSummary[approvalStageKey].approvers || [];

            if (approvers.length === 2) {
              pendingTO.push(initiative);
              categorized = true;
            } else if (approvers.length === 3) {
              approvedTO.push(initiative);
              categorized = true;
            }
          }
        }
      }
    }
    if (!categorized) {
      notSetTO.push(initiative);
    }
  });

  return { pendingTO, approvedTO, notSetTO };
};

export default pendingApprovalForToFinance;